<template>
  <div class="settings-connections">
    <h3
      v-t="'page.account.settings.connections.title'"
      class="text-h5 text-uppercase font-weight-extrabold mb-4"
    />

    <v-sheet
      v-for="provider in PROVIDERS"
      :key="provider.id"
      color="grey800"
      class="mb-2 d-flex"
    >
      <div class="grey600 pa-4 d-flex align-center justify-center">
        <fai
          fixed-width
          :icon="provider.icon"
          :style="{color: provider.color}"
          class="text-h5"
        />
      </div>
      <div class="flex-grow-1 align-self-center py-3 px-3">
        <h4 v-t="provider.name" class="text-body-1 text-capitalize font-weight-semibold" />
        <h5
          v-if="connections[provider.id]"
          class="text-caption text--secondary"
        >
          <span>#{{ connections[provider.id].referenceId }}</span>
          <span class="ml-1 text--disabled">
            ({{ connections[provider.id].lastUpdatedAt | toDateFormat('YYYY-MM-DD HH:mm') }})
          </span>
        </h5>
      </div>

      <div class="actions d-flex align-center pr-3">
        <v-btn
          v-if="connections[provider.id]"
          color="primary800 primary200--text"
          class="text-caption font-weight-semibold"
          :ripple="false"
          tile depressed
          :loading="loading.link"
          @click="onUnlink(provider.id)"
        >
          <fai :icon="['far', 'times']" class="mr-2" />
          <span v-t="'cta.unlink'" />
        </v-btn>

        <v-btn
          v-else
          color="blue700 blue200--text"
          class="text-caption font-weight-semibold"
          :ripple="false"
          tile depressed
          :loading="loading.link"
          @click="onLink(provider.id)"
        >
          <fai :icon="['fas', 'plus']" class="mr-2" />
          <span v-t="'cta.link_account'" />
        </v-btn>
      </div>
    </v-sheet>

    <v-checkbox
      v-model="withEmail"
      hide-details dense
      color="grey100"
      class="mt-3"
      :label="$t('page.account.settings.connections.promo')"
    />
  </div>
</template>

<script>
import User from '@/store/models/user/User'
import { oauthLink } from '@/api/auth'
import { mapActions, mapMutations } from 'vuex'

const PROVIDERS = ['discord']

const PROVIDER_ICONS = {
  discord: ['fab', 'discord'],
  twitter: ['fab', 'twitter'],
}

const PROVIDER_COLORS = {
  discord: '#5865f2',
  twitter: '#1DA1F2',
}

export default {
  props: {
    user: {
      type: [User, Object],
      required: true,
    },
  },
  data() {
    return {
      loading: {
        link: false,
      },
      withEmail: true,
    }
  },
  computed: {
    PROVIDERS() {
      return PROVIDERS.map(i => ({
        id: i,
        name: `page.account.settings.connections.provider.${i}`,
        icon: PROVIDER_ICONS[i],
        color: PROVIDER_COLORS[i],
      }))
    },
    connections() {
      return this.user.connections.reduce((acc, v) => {
        acc[v.type] = v
        return acc
      }, {})
    },
  },
  methods: {
    ...mapActions({
      unlinkConnection: 'user/unlinkConnection',
    }),
    ...mapMutations({
      removeConnection: 'user/removeConnection',
    }),
    async onLink(provider) {
      if (this.loading.link) return

      this.loading.link = true
      try {
        const authUrl = await oauthLink({
          provider,
          withEmail: this.withEmail,
        })

        this.$modal.open('oauth', { maxWidth: 320 }, { authUrl, provider })
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading.link = false
      }
    },
    async onUnlink(provider) {
      if (this.loading.link) return

      this.loading.link = true
      try {
        await this.unlinkConnection(provider)
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading.link = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.settings-connections {

}
</style>
